import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PhotoclipPage } from './photoclip';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
  declarations: [PhotoclipPage],
  imports: [ComponentsModule, IonicPageModule.forChild(PhotoclipPage)],
})
export class PhotoclipPageModule {}



// WEBPACK FOOTER //
// ./src/pages/photoclip/photoclip.module.ts